export default __webpack_public_path__ + "static/media/Ready-to-engage.b4bf77c6.png";